export var ComboboxCssClass;
(function (ComboboxCssClass) {
    ComboboxCssClass["Base"] = "iress-combobox";
    ComboboxCssClass["Input"] = "iress-combobox__input";
    ComboboxCssClass["Menu"] = "iress-combobox__menu";
    ComboboxCssClass["HiddenInput"] = "iress-combobox__hidden-input";
    ComboboxCssClass["Popover"] = "iress-combobox__popover";
    ComboboxCssClass["OptionMeta"] = "iress-combobox__option-meta";
    ComboboxCssClass["OptionMetaText"] = "iress-combobox__option-meta__text";
    ComboboxCssClass["TagListInput"] = "iress-combobox__tag-list-input";
    ComboboxCssClass["TagListInputWrapper"] = "iress-combobox__tag-list-input__wrapper";
    ComboboxCssClass["TagListInputWrapperInner"] = "iress-combobox__tag-list-input__wrapper-inner";
    ComboboxCssClass["TagListInputLabel"] = "iress-combobox__tag-list-input__label";
    ComboboxCssClass["Multiple"] = "iress-combobox__multiple";
    ComboboxCssClass["Watermark"] = "iress-combobox__watermark";
})(ComboboxCssClass || (ComboboxCssClass = {}));
export var ComboboxSlot;
(function (ComboboxSlot) {
    ComboboxSlot["Prepend"] = "prepend";
    ComboboxSlot["Append"] = "append";
})(ComboboxSlot || (ComboboxSlot = {}));
//# sourceMappingURL=combobox.types.js.map